import { Breadcrumb } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { firstLetterUpper } from '../helpers';
import Constants from './Constants';
import { useOwnerContext } from '../Context/OwnerContext/OwnerContext';
import { useAppDispatch, useAppSelector } from '../Redux/Store';
import { setRoute, setShowModal } from '../Redux/Reducer/feedBillUpdate';
import { setShouldAllowBuyPoPageChange } from '../apps/shippingTracker/modules/BuyPo/actions/buyPoActions';
import { setShouldAllowShipPoPageChange } from '../apps/shippingTracker/modules/shippo/reducers/shipPoReducer';

const BreadCrumbs = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { selectedOwner } = useOwnerContext();
    const pathnames = pathname.split('/').filter(x => x);
    const routePath = pathnames?.filter(element => isNaN(+element));
    const routePathValues = routePath?.map(
        element => Constants.headerConstants[element.toLowerCase()],
    );
    const { lastUpdate } = useAppSelector(state => state.feedBillUpdate);
    const { shouldAllowPageChange } = useAppSelector(state => state.buyPO);
    const { shouldAllowPageChange: shouldAllowShipPoPageChange } =
        useAppSelector(state => state.shipPO);
    const dispatch = useAppDispatch();

    const getFirstName = (index: number, name?: string) => {
        if (name === undefined) {
            return (
                routePath[index - 1] === 'editFeedBill' &&
                firstLetterUpper('Feed Bill')
            );
        } else {
            return firstLetterUpper(name);
        }
    };

    const handleNavigate = (name: string) => {
        if (name === 'Feed Bills') {
            navigate('feedbills');
        } else {
            if (pathname.includes('buypos') && !handleBuyPoPageChange(name))
                return;
            if (pathname.includes('shippos') && !handleShipPoPageChange(name))
                return;
            navigate(name.replaceAll(' ', ''));
        }
    };

    const handleHomeClick = () => {
        if (pathname.includes('buypos')) handleBuyPoPageChange();
        else if (pathname.includes('shippos')) handleShipPoPageChange();
        else handleFinancePageChange();
    };

    const handleFinancePageChange = () => {
        if (lastUpdate) {
            dispatch(setShowModal(true));
            dispatch(setRoute('/'));
        } else {
            navigate('/');
        }
    };

    const handleBuyPoPageChange = (route = '/'): boolean => {
        if (shouldAllowPageChange.lastUpdate) {
            dispatch(
                setShouldAllowBuyPoPageChange({
                    ...shouldAllowPageChange,
                    showModal: true,
                    route: route.toLowerCase(),
                }),
            );
            return false;
        } else {
            navigate(route.toLowerCase());
            return true;
        }
    };

    const handleShipPoPageChange = (route = '/'): boolean => {
        if (shouldAllowShipPoPageChange.lastUpdate) {
            dispatch(
                setShouldAllowShipPoPageChange({
                    ...shouldAllowShipPoPageChange,
                    showModal: true,
                    route: route.toLowerCase(),
                }),
            );
            return false;
        } else {
            navigate(route.toLowerCase());
            return true;
        }
    };

    return (
        <>
            {!(
                (pathname === '/lots' && selectedOwner.name !== 'All') ||
                false
            ) && (
                <Breadcrumb className="breadcrumb">
                    <Breadcrumb.Item onClick={handleHomeClick}>
                        {Constants.home}
                    </Breadcrumb.Item>
                    {routePathValues?.map((name, index) => {
                        if (name === undefined) return null;

                        const isLast = index === routePathValues.length - 1;
                        const isSecondToLast =
                            index === routePathValues.length - 2;
                        const isLastItemUndefined =
                            routePathValues[routePathValues.length - 1] ===
                            undefined;

                        if (isLast || (isSecondToLast && isLastItemUndefined)) {
                            return (
                                <Breadcrumb.Item active={isLast} key={index}>
                                    {getFirstName(index, name)}
                                </Breadcrumb.Item>
                            );
                        } else {
                            return (
                                <Breadcrumb.Item
                                    key={index}
                                    onClick={() => handleNavigate(name)}
                                >
                                    {firstLetterUpper(name)}
                                </Breadcrumb.Item>
                            );
                        }
                    })}
                </Breadcrumb>
            )}
        </>
    );
};

export default BreadCrumbs;
